import { render } from "./HostResetCheckTime.vue?vue&type=template&id=452b985a"
import script from "./HostResetCheckTime.vue?vue&type=script&lang=js"
export * from "./HostResetCheckTime.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__